export const TABLE_TEST_IDS = {
  search: 'table-search-input',
  settings: 'table-settings-button',
  savePreferences: 'save-preferences',
} as const;

// INFO: rio-uikit's own toolbar search class. It carries the 300px column width and the full-width
// behaviour below 480px, which the shared SearchField deliberately does not own.
export const TABLE_TOOLBAR_SEARCH_CLASS = 'table-toolbar-search margin-bottom-0';
